import React from 'react';
import { Container, ContentText } from './content-result-success-style';
import { BaSeIcon } from '@base/react';

const ContentResultSuccess = () => {
  return (
    <Container>
      <BaSeIcon
        name="check-circle"
        size="32"
        description="icon-times"
        color="#fff"
      />
      <ContentText>
        <strong>Seu questionário foi enviado com sucesso!</strong>
        <p>
          Muito obrigado por compartilhar sua opinião sobre mim.

        </p>
      </ContentText>
    </Container>
  );
};

export default ContentResultSuccess;
